import { apiInstance } from '@/utils';

interface ISaveDemoBookingConfigPayload {
  chatToken: string;
  enabled: boolean;
  title?: string;
  description?: string;
  action_text?: string;
  selectedCalendar?: {
    type: string;
    authId: number;
    config?: object;
  };
  calendar_config?: {
    regional_mode?: boolean;
    mappings?: Record<string, {
      type: string;
      auth_id: number;
    }>;
    availability?: {
      timezone: string;
      slot_minutes: number;
      buffer_minutes?: number;
      days: Record<string, {
        enabled: boolean;
        start: string;
        end: string;
      }>;
    };
  };
}

export const getDemoBookingConfig = async (chatToken: string) => {
  const response = await apiInstance.get(`/private/chatbot/demo-booking-config/${chatToken}`);
  return response.data;
};

export const saveDemoBookingConfig = async (data: ISaveDemoBookingConfigPayload) => {
  const { chatToken, ...payload } = data;
  const response = await apiInstance.post(`/private/chatbot/demo-booking-config/${chatToken}`, payload);
  return response.data;
};